
export default class Clubreg {

    constructor() {
        this.init();
    }

    init() {
        if ($('.felhasznalok-klubreg-kont').length > 0)
        {
            $('.felhasznalok-klubreg-kont .belepes-form button').on('click', e => {
                let fn = $(e.currentTarget).data('fn');
                if (fn == 'check_email')
                {
                    let error = this.checkEmail();
                    if (!error) {
                        $("div.errordiv").remove();
                        $('<span>').addClass('spinner fa fa-cog fa-spin').appendTo($('.felhasznalok-klubreg-kont .belepes-form .type-email'))
                        $.post('/index.php/felhasznalok/regboxservice/checkemail', { email: $('.felhasznalok-klubreg-kont .belepes-form #email').val(), regformtoken: $('input[name="regformtoken"]').val() }, ret => {
                            $(".spinner").remove();
                            if (ret.exists) {

                                /*
                                if (ret.exists_facebook) {
                                    $('.belepes-form > form .login-message').remove();

                                    console.log(lngMessages["Már regisztáltál Facebook fiókkal. Kérünk, jelentkezz be azzal."])
                                    $('<div>')
                                        .addClass('login-message')
                                        .text(lngMessages["Már regisztáltál Facebook fiókkal. Kérünk, jelentkezz be azzal."])
                                        .prependTo($('.belepes-form > form'));

                                    setTimeout(function () { $('.belepes-form > form .login-message').remove() }, 10000);
                                } else if (ret.exists_google) {
                                    $('.belepes-form > form .login-message').remove();

                                    $('<div>')
                                        .addClass('login-message')
                                        .text(lngMessages["Már regisztáltál Google fiókkal. Kérünk, jelentkezz be azzal."])
                                        .prependTo($('.belepes-form > form'));

                                    setTimeout(function () { $('.belepes-form > form .login-message').remove() }, 10000);
                                } else {*/

                                    $('.felhasznalok-klubreg-kont .belepes-form .type-email').addClass('only-text');
                                    $('.felhasznalok-klubreg-kont .belepes-form .type-email').find('input').attr('readonly', true);
                                    $('.felhasznalok-klubreg-kont .belepes-form .password-field').removeClass('hide');
                                    $('.felhasznalok-klubreg-kont .belepes-form .forget-password').removeClass('hide');

                                    let passwordText = $('.felhasznalok-klubreg-kont .belepes-form button').data('password_text');
                                    $('.felhasznalok-klubreg-kont .belepes-form button').text(passwordText);

                                    $(e.currentTarget).data('fn', 'submit_login');
                                /*}*/
                            } else {
                                $(e.currentTarget).parents('form').find('[name="fn"]').val('reg');
                                $(e.currentTarget).parents('form').submit()
                            }
                        });
                    }
                } else if (fn == 'submit_login') {
                    let email = $('.felhasznalok-klubreg-kont .belepes-form #email').val();
                    let jelszo = $('.felhasznalok-klubreg-kont .belepes-form #jelszo').val();

                    let error = this.loginformcheck();

                    if (!error)
                    {
                        $('.felhasznalok-klubreg-kont .belepes-form .password-field').addClass('pad-left');
                        $('<span>').addClass('spinner poz-left fa fa-cog fa-spin').appendTo($('.felhasznalok-klubreg-kont .belepes-form .password-field'))

                        $.post('/index.php/felhasznalok/loginservice/login', { email: email, kartyaszam: jelszo, forcelang: $('body').attr('data-aktlang') }, retlogin => {
                            if (retlogin.state == true)
                            {
                                window.location.reload()
                            } else {
                                $("div.errordiv").remove();
                                $(".errorredborder").removeClass("errorredborder");
                                $(".errordiv").text("");
                                if(!$(".errordiv").hasClass("hide")){
                                    $(".errordiv").addClass("hide");
                                }
                                $('.felhasznalok-klubreg-kont .belepes-form .password-field').removeClass('pad-left');
                                $('.felhasznalok-klubreg-kont .belepes-form .password-field .spinner').remove();
                                let errorobj = { "str": retlogin.msg, "obj": ".felhasznalok-klubreg-kont .belepes-form #jelszo" };
                                this.drawError(errorobj)

                            }
                        },'json')
                    }
                }
            })

            $('.felhasznalok-klubreg-kont .password-field .toggle-type').on('click', e => {

                e.preventDefault();
                if ($(e.currentTarget).parent().find('input').attr('type') == 'text') {
                    $(e.currentTarget).parent().find('input').attr('type', 'password')
                    $(e.currentTarget).removeClass('on')
                } else {
                    $(e.currentTarget).parent().find('input').attr('type', 'text')
                    $(e.currentTarget).addClass('on')
                }

            });

            $(".felhasznalok-klubreg-kont select[name='holtalaltrank']").change(function(){
                if ($(this).val() == 11)
                {
                    $(".felhasznalok-klubreg-kont .form-item .holtalaltrank-text-kont").removeClass('hide')
                } else {
                    $(".felhasznalok-klubreg-kont .form-item .holtalaltrank-text-kont").addClass('hide')
                    $(".felhasznalok-klubreg-kont .form-item .holtalaltrank-text-kont input").val('')
                }
            })


            $('#elfelejtett-form-submit').on("click", e => {
                var error = false;
                var errorobj = [];

                if ($("#elfelejtettjelszo_form [name='email']").val() == "")
                {
                    error = true;
                    errorobj.push({"str": lngMessages["Email nem lehet üres"], "obj": "#elfelejtettjelszo_form [name='email']"});
                } else {
                    $("[name='email']").val($("[name='email']").val().toLowerCase())
                    var emailReg = /^([A-Za-z0-9_\-\+\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
                    if (!emailReg.test($("#elfelejtettjelszo_form [name='email']").val()))
                    {
                        error = true;
                        errorobj.push({"str": lngMessages["Email cím nem tűnik érvényesnek"], "obj": "#elfelejtettjelszo_form [name='email']"});
                    }
                }

                if (!error)
                {
                    $("#elfelejtettjelszo_form").submit();
                } else {
                    $("div.errordiv").remove();
                    $(".errorredborder").removeClass("errorredborder");
                    $.each(errorobj, function(i, eobj){
                        var err = "<div class='error errordiv'>"+eobj.str+"</div>";
                        $(eobj.obj).addClass("errorredborder").parents('.form-item').append(err)
                    })
                    return true
                }
            })

            $('#felhasznalok_regform #checkregform').on("click", e => {
                this.regformcheck();
            });

            $('#elfelejtett-reset-form-submit').on("click", e => {
                var error = false;
                var errorobj = [];

                if ($("#elfelejtettjelszoreset_form [name='password']").val() == "")
                {
                    error = true;
                    errorobj.push({"str": lngMessages["Jelszó kötelező"], "obj": "#elfelejtettjelszoreset_form [name='password']"});
                }

                if (!error)
                {
                    $("#elfelejtettjelszoreset_form").submit();
                } else {
                    $("div.errordiv").remove();
                    $(".errorredborder").removeClass("errorredborder");
                    $.each(errorobj, function(i, eobj){
                        var err = "<div class='error errordiv'>"+eobj.str+"</div>";
                        $(eobj.obj).addClass("errorredborder").parents('.form-item').append(err)
                    })
                    return true
                }
            })


            if ($('.belepes-form').length > 0)
            {
                if (typeof window.google_client_id !== 'undefined' && typeof google !== 'undefined' && google.accounts) {
                    const codeClient = google.accounts.oauth2.initCodeClient({
                        client_id: window.google_client_id,
                        scope: 'email profile',
                        ux_mode: 'redirect',
                        redirect_uri: window.google_redirect_uri,
                    });
                    $('.belepes-form .extra-login.google-btn a').on('click', e => {
                        e.preventDefault();
                        codeClient.requestCode();
                    });
                }

                if (typeof window.facebook_login_app_id != 'undefined')
                {
                    this.fb_init();
                }
            }

        }

        if (typeof window.google_showPopUp_window != "undefined")
        {
            this.google_showPopUp('/clubcardreg?saveconnect=1&glogin=1');
        }

        if (typeof window.google_showPopUp_emptywindow != "undefined")
        {
            this.google_showPopUp('/clubcardreg?emptypopoup=1');
        }
    }

    /**
     * @returns bool
     */
    checkEmail()
    {
        var error = false;
        var errorobj = [];

        if ($(".felhasznalok-klubreg-kont .belepes-form #email").val() == "")
        {
            error = true;
            errorobj.push({"str": lngMessages["Email nem lehet üres"], "obj": ".felhasznalok-klubreg-kont .belepes-form #email"});
        } else {
            let emailReg = /^\S+@\S+\.\S+$/;
            if (!emailReg.test($("[name='email']").val()))
            {
                error = true;
                errorobj.push({"str": lngMessages["Email cím nem tűnik érvényesnek"], "obj": ".felhasznalok-klubreg-kont .belepes-form #email"});
            }

        }

        if (error)
        {
            $("div.errordiv").remove();
            $(".errorredborder").removeClass("errorredborder");
            $(".errordiv").text("");
            if(!$(".errordiv").hasClass("hide")){
                $(".errordiv").addClass("hide");
            }
            $.each(errorobj, function(i, eobj){
                if ($(eobj.obj).length > 0)
                {
                    $(eobj.obj).addClass("errorredborder");

                    var par = $(eobj.obj).parents('.form-item');
                    if (par.length > 0)
                    {
                        if ($(eobj.obj).parent().find('errordiv').length == 0)
                        {
                            $('<div>').addClass('errordiv hide').appendTo($(eobj.obj).parent())
                        }
                    }

                    par.find(".errordiv").text(eobj.str).removeClass("hide")

                }
            })

        }

        return error;
    }

    loginformcheck()
    {
        var error = false;
        var errorobj = [];

        if ($(".felhasznalok-klubreg-kont .belepes-form form #jelszo").length>0){
            if ($(".felhasznalok-klubreg-kont .belepes-form form #jelszo").val() == "")
            {
                error = true;
                errorobj.push({"str": lngMessages["Jelszó kötelező"], "obj": ".felhasznalok-klubreg-kont .belepes-form form #jelszo"});
            }

        }

        if (error)
        {
            $("div.errordiv").remove();
            $(".errorredborder").removeClass("errorredborder");
            $(".errordiv").text("");
            if(!$(".errordiv").hasClass("hide")){
                $(".errordiv").addClass("hide");
            }
            $.each(errorobj, function (i, eobj) {
                Clubreg.drawError(eobj)
            })
            $('html, body').animate({
                scrollTop: $("#felhasznalok_regform").offset().top - 20
            }, 500);
        }

        return error;
    }

    drawError(eobj)
    {
        if ($(eobj.obj).length > 0)
        {
            if ($(eobj.obj).prop('tagName').toLowerCase() == "select") {
                $(eobj.obj).parents('.form-item').find(".fancy-select-display").addClass("errorredborder")
            } else {

                $(eobj.obj).addClass("errorredborder");

                var par = $(eobj.obj).parents('.form-item');
                if (par.length > 0)
                {
                    if (par.hasClass('checkbox'))
                    {
                        $('<div>').addClass('errordiv hide').appendTo($(par).find('label'))
                    } else {
                        $('<div>').addClass('errordiv hide').appendTo($(par))
                    }
                }

                par.find(".errordiv").text(eobj.str).removeClass("hide")
            }
        }
    }

    regformcheck()
    {
        var error = false;
        var errorobj = [];

        if ($("#felhasznalok_regform [name='nev']").val() == "")
        {
            error = true;
            errorobj.push({"str": lngMessages["Vezetéknév kötelező"], "obj": "#felhasznalok_regform [name='nev']"});
        }

        if ($("#felhasznalok_regform [name='keresztnev']").val() == "")
        {
            error = true;
            errorobj.push({"str": lngMessages["Keresztnév kötelező"], "obj": "#felhasznalok_regform [name='keresztnev']"});
        }

        var pwerror = false;
        if ($("#felhasznalok_regform [name='password']").length>0){
            if ($("#felhasznalok_regform [name='password']").val() == "")
            {
                error = true;
                pwerror = true;
                errorobj.push({"str": lngMessages["Jelszó kötelező"], "obj": "#felhasznalok_regform [name='password']"});
            }

            if (!pwerror)
            {
                var goodpass = true;
                if ($("#felhasznalok_regform [name='password']").val().length < 6)
                {
                    goodpass = false;
                }

                if (!/[a-z]/.test($("#felhasznalok_regform [name='password']").val().toLowerCase()))
                {
                    goodpass = false;
                }
                if (!/[0-9]/.test($("#felhasznalok_regform [name='password']").val()))
                {
                    goodpass = false;
                }

                if (!goodpass)
                {
                    error = true;
                    errorobj.push({"str": lngMessages["Jelszó erőssége nem megfelelő"], "obj": "#felhasznalok_regform [name='password']"});
                }
            }

        }

        if (!$("#felhasznalok_regform [name='aszf']").is(':checked'))
        {
            error = true;
            errorobj.push({"str": lngMessages["Kötelező mező"], "obj": "#felhasznalok_regform [name='aszf']"});
        }

        if (!$("#felhasznalok_regform [name='policy']").is(':checked'))
        {
            error = true;
            errorobj.push({"str": lngMessages["Kötelező mező"], "obj": "#felhasznalok_regform [name='policy']"});
        }

        if (!error)
        {
            $("#felhasznalok_regform").submit();
        } else {
            $("div.errordiv").remove();
            $(".errorredborder").removeClass("errorredborder");
            $(".errordiv").text("");
            if(!$(".errordiv").hasClass("hide")){
                $(".errordiv").addClass("hide");
            }
            $.each(errorobj, function(i, eobj){
                if ($(eobj.obj).length > 0)
                {
                    if ($(eobj.obj).prop('tagName').toLowerCase() == "select") {
                        $(eobj.obj).parents('.form-item').find(".fancy-select-display").addClass("errorredborder")
                    } else {

                        $(eobj.obj).addClass("errorredborder");

                        var par = $(eobj.obj).parents('.form-item');
                        if (par.length > 0)
                        {
                            if (par.hasClass('checkbox'))
                            {
                                $('<div>').addClass('errordiv hide').appendTo($(par).find('label'))
                            } else {
                                $('<div>').addClass('errordiv hide').appendTo($(par))
                            }
                        }

                        par.find(".errordiv").text(eobj.str).removeClass("hide")

                    }
                }
            })
            $('html, body').animate({
                scrollTop: $("#felhasznalok_regform").offset().top - 20
            }, 500);
            return true
        }
    }

    fb_statusChangeCallback(response)
    {
        if (response.status === 'connected')
        {
            FB.api('/me', { fields: 'id, name, email, first_name, last_name' }, function(response) {

                response['method'] = 'check_login';
                $.post('/belepes/fb_login', response, function (res) {
                    document.location.reload(true);
                });
            });
        } else {
            console.log(response)
        }
    }


    fb_init() {

        window.fbAsyncInit = function () {

            FB.init({
                appId: window.facebook_login_app_id,
                cookie: true,
                version: 'v22.0'
            });


            FB.getLoginStatus(function (response) {
                // belepes.fb_statusChangeCallback(response);
            });

        };

        $('a#fblogout').on('click', e => {
            e.preventDefault()
            FB.logout(function (response) {

            });
        });

        $('.belepes-form .extra-login.facebook-btn a').on('click', e => {
            e.preventDefault()

            FB.login(function (response) {
                if (response.status === 'connected') {
                    FB.api('/me', { fields: 'id, name, email, first_name, last_name' }, function(fbresp) {

                        if (typeof fbresp.email == 'string') {
                            let checkData = {
                                'mode': 'fb',
                                'email': fbresp.email,
                                'id': fbresp.id
                            };
                            $.get('/index.php/felhasznalok/loginservice/check_social_user_exists', checkData, function (stres) {
                                if (stres.exists) {
                                    window.Clubreg.fb_showPopUp(fbresp)
                                } else {
                                    fbresp['method'] = 'new_login';
                                    $.post('/clubcardreg?fblogin=1', fbresp, function (res) {
                                        window.location.reload();
                                    });
                                }
                            });
                        }
                    });
                }
            }, {scope: 'public_profile,email'});
        })
    }

    fb_showPopUp(fbresp)
    {
        var popWindowOverlay = $('<div>').addClass('pms-overlay');
        popWindowOverlay.appendTo($('body'))
        var popWindow = $('<div>').addClass('pop-window');
        var popClose = $('<a>').addClass('pop-closeme').attr('href', '');
        popClose.on('click', e => {
            e.preventDefault();
            $(e.currentTarget).parents('.pop-window').remove();
            $('.pms-overlay').remove();
        });
        popClose.appendTo(popWindow);
        var popBody = $('<div>').addClass('pop-body');

        var popBodyHead = $('<div>').addClass('body-head').text(lngMessages["Szeretné összekötni a fiókjait?"]);
        popBodyHead.appendTo(popBody);
        var popBodyMessage = $('<div>').addClass('body-message').text(lngMessages['Úgy tűnik ezekkel az adatokkal már korábban létrehozott egy Pödör fiókot. Szeretné, hogy csatoljuk a felhasználót?']);
        popBodyMessage.appendTo(popBody);

        var popBodyFooter = $('<div>').addClass('body-footer');

            var popConfirmButton = $('<a>').addClass('btn btn-default-white').attr('href', '').text(lngMessages["Igen, a fiókok összekötése"]);

            popConfirmButton.on('click', e => {
                e.preventDefault();

                fbresp['method'] = 'new_login';
                $.post('/clubcardreg?fblogin=1', fbresp, function (res) {
                    window.location.reload();
                });
            });
            popConfirmButton.appendTo(popBodyFooter);


        popBodyFooter.appendTo(popBody);

        popBody.appendTo(popWindow);

        popWindow.appendTo($('body'));

    }

    google_showPopUp(loginurl)
    {
        var popWindowOverlay = $('<div>').addClass('pms-overlay');
        popWindowOverlay.appendTo($('body'))
        var popWindow = $('<div>').addClass('pop-window');
        var popClose = $('<a>').addClass('pop-closeme').attr('href', '');
        popClose.on('click', e => {
            e.preventDefault();
            $(e.currentTarget).parents('.pop-window').remove();
            $('.pms-overlay').remove();
        });
        popClose.appendTo(popWindow);
        var popBody = $('<div>').addClass('pop-body');

        var popBodyHead = $('<div>').addClass('body-head').text(lngMessages["Szeretné összekötni a fiókjait?"]);
        popBodyHead.appendTo(popBody);
        var popBodyMessage = $('<div>').addClass('body-message').text(lngMessages['Úgy tűnik ezekkel az adatokkal már korábban létrehozott egy Pödör fiókot. Szeretné, hogy csatoljuk a felhasználót?']);
        popBodyMessage.appendTo(popBody);

        var popBodyFooter = $('<div>').addClass('body-footer');

            var popConfirmButton = $('<a>').addClass('btn btn-default-white').attr('href', loginurl).text(lngMessages["Igen, a fiókok összekötése"]);
            popConfirmButton.appendTo(popBodyFooter);


        popBodyFooter.appendTo(popBody);

        popBody.appendTo(popWindow);

        popWindow.appendTo($('body'));

    }

}

